/* eslint-disable react/destructuring-assignment */
import Icon, {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { Bar, Column, Pie } from "@ant-design/plots";
import { useQuery } from "@apollo/client";
import {
  Alert,
  Avatar,
  Button,
  DatePicker,
  Dropdown,
  Pagination,
  Select,
  Skeleton,
  Table,
  Tag,
  Tooltip,
  Popover,
} from "antd";
import dayjs from "dayjs";
import { navigate } from "gatsby";
import { capitalize } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import {
  GET_APPOINTMENT_ANALYSIS,
  GET_APPOINTMENTS_BY_SALES_PERSON,
  GET_DASHBOARD_ANALYTICS,
  GET_DATA_BY_SOURCE,
  GET_ENGAGEMENT_ANALYTICS,
  GET_LEAD_CONTECTED_BY_SOURCE,
  GET_LEAD_ENGAGEMENT_ANALYSIS,
  GET_REVIEW_STATUS_ANALYSIS,
  GET_USER_MESSAGE_ANALYSIS,
  GET_USER_MESSAGE_RESPONSE_TIME_ANALYSIS,
  GET_USER_MESSAGE_TYPE_ANALYSIS,
  GET_USER_REVIEW_ANALYSIS,
} from "../../../graphql/query";
import useLang from "../../../hooks/useLang";
import { DashboardArrow } from "../../../icons/js/DashboardArrow";
import { DownIcon } from "../../../icons/js/DownIcon";
import { EngagementVector } from "../../../icons/js/EngagementSVG";
import PencilIcon from "../../../icons/js/PencilIcon";
import { DoubleRightIcon } from "../../../icons/js/RightIcon";
import { parseVehicle } from "../../../library/utils";
import { setQuickFilters } from "../../../redux/slices/leadSlice";
import UserSelector from "../../commonComponents/userSelector";
import { convertToInitials } from "../../layoutComponent/layoutHelpers";
import {
  activityAnalysis,
  appointmentsAnalytics,
  convertMinutesToHour,
  convertToTitleCase,
  filterByRange,
  filterByStatus,
  LAST_MONTH,
  LAST_WEEK,
  leadBySource,
  THIS_MONTH,
  LAST_30_DAYS,
  THIS_WEEK,
} from "./dashboardHelpers";
import GraphAnalysis from "./graphAnalysis";

/**
 *
 * @param {{filterType:string, handleFilter:(value:string)=>{}, dateRange:[], setDateRange:([])=>void}} props
 * @returns
 */
export const FilterSelector = props => {
  const [lang] = useLang();
  const { filterType, handleFilter, dateRange, setDateRange } = props;
  const [isCustomDate, setisCustomDate] = useState(false);
  return isCustomDate ? (
    <div className="flex-row-centered gap-1">
      <DatePicker.RangePicker
        onChange={values => {
          if (values) {
            const startDate = values[0] ? dayjs(values[0]).startOf("day") : null;
            const endDate = values[1] ? dayjs(values[1]).endOf("day") : null;
            setDateRange([startDate?.toISOString(), endDate?.toISOString()]);
          } else {
            setDateRange([]);
          }
        }}
      />
      <CloseCircleOutlined
        className="cursor-pointer"
        onClick={() => {
          setisCustomDate(false);
          setDateRange([]);
        }}
      />
    </div>
  ) : (
    <Select
      value={filterType}
      className="w-[200px]"
      options={[
        {
          value: "TODAY",
          label: "Today",
        },
        {
          value: "YESTERDAY",
          label: "Yesterday",
        },
        {
          value: THIS_MONTH,
          label: "This Month",
        },
        {
          value: LAST_MONTH,
          label: "Last Month",
        },
        {
          value: THIS_WEEK,
          label: "This Week",
        },
        {
          value: LAST_WEEK,
          label: "Last Week",
        },
        {
          value: LAST_30_DAYS,
          label: "Last 30 Days",
        },
      ]}
      dropdownRender={menu => {
        return (
          <>
            {menu}
            <span onClick={() => setisCustomDate(true)} className="cursor-pointer p-2 pl-3 ">
              Custom date
            </span>
          </>
        );
      }}
      onChange={handleFilter}
    />
  );
};
/**
 *
 * @param {{total:number, pageSize:number, page:number,length:number, onChange:(page:number,pageSize:number)=>void,pageSizeOptions:number[]}} props
 * @returns
 */
export const AnalyticsPagination = props => {
  return (
    <div className="flex-row-centered flex-wrap gap-1 justify-between">
      <span className="text-sm font-[400] text-grey-500">
        Showing {props.length || 0} out of {props.total}
      </span>
      <Pagination
        showSizeChanger
        size="small"
        className="analytics-pagination"
        {...props}
        current={props.page}
        prevIcon={
          <div className="pagination-btns">
            <ArrowLeftOutlined />
          </div>
        }
        nextIcon={
          <div className="pagination-btns">
            <ArrowRightOutlined />
          </div>
        }
      />
    </div>
  );
};
/**
 * ![Messages Sent vs. Received](https://img001.prntscr.com/file/img001/oZu_JQUqQ_2uWnYvOU2lGQ.png)
 * ### [Figma Link](https://www.figma.com/design/NDVwkatBby4TFCN5oag0D1/1.-Web?node-id=12729-12531&t=ojvDzhXjpXYtiRcI-4)
 * @param {{
 * type: "NORMAL" | "GROUP" | "STACK",
 * xField?:string,
 * yField?:string,
 * seriesField?:string}} props
 * @returns
 */
export const UserAnalytics = props => {
  const locationId = useSelector(state => state.location.locationId);
  const [analytics, setanalytics] = useState({ data: [], count: 0 });
  const [dateRange, setDateRange] = useState([]);
  const [appointmentAnalytics, setappointmentAnalytics] = useState({ data: [] });
  const [responseRecievedByAttempFilter, setResponseRecievedByAttempFilter] =
    useState(LAST_30_DAYS);
  const [userIds, setuserIds] = useState([]);
  const [params, setparams] = useState({
    page: 1,
    pageSize: 10,
  });
  const userCondition = useMemo(() => userIds.length > 0 && userIds.length <= 3, [userIds]);
  const { refetch: getResponseRecivedByAttemp, loading: engagementAnayticLoader } = useQuery(
    GET_USER_MESSAGE_ANALYSIS,
    {
      // fetchPolicy: "network-only",
      nextFetchPolicy: "cache-and-network",
      variables: {
        filterType: responseRecievedByAttempFilter,
        userIds,
        dateRange,
        ...(userCondition ? {} : { ...params, orderBy: "fullName", orderDirection: "asc" }),
      },
      onCompleted: res => {
        setanalytics(res.getUserMessageAnalysis);
      },
    }
  );

  useEffect(() => {
    setuserIds([]);
  }, [locationId]);
  return (
    <div className="flex-col-centered gap-1">
      <div className="flex-row-centered justify-between">
        <span className="dashboard-title-label">Messages Sent vs. Received</span>
        <div className="flex-row-centered gap-1">
          <UserSelector
            containerClassName=""
            handleUsersSelection={userIds => setuserIds(userIds)}
            multiple
            allEmptyArray
            className="w-[200px]"
            userIds={userIds}
            value={userIds}
            // maxSelection={3}
          />
          <FilterSelector
            filterType={responseRecievedByAttempFilter}
            handleFilter={setResponseRecievedByAttempFilter}
            dateRange={dateRange}
            setDateRange={setDateRange}
          />
        </div>
      </div>
      <div className="sm:flex-row-centered flex-col-centered gap-1">
        {/* Messages Sent vs. Received graph */}
        <GraphAnalysis
          graphKey="messageSentRecieved"
          label="Messages Sent vs. Received"
          data={analytics.data.map(item => ({
            ...item,
            name: convertToTitleCase(item.name),
          }))}
          width={8}
          colors={["#5B8FF9", "#5AD8A6", "#A855F7"]}
          API={getResponseRecivedByAttemp}
          filterType={responseRecievedByAttempFilter}
          setFilterType={setResponseRecievedByAttempFilter}
          loader={engagementAnayticLoader}
          onChangeUsers={userIds => setuserIds(userIds)}
          userIds={userIds}
          type={props.type || "GROUP"}
          xField="userFullName"
          yField="value"
          seriesField="name"
          pagination={false}
          showFilters={false}
        />
        {/* Appointment analysis graph */}
        {userCondition && (
          <AppointmentBySalesPersonGraph
            userIds={userIds}
            responseRecievedByAttempFilter={responseRecievedByAttempFilter}
            userCondition={userCondition}
            setappointmentAnalytics={setappointmentAnalytics}
            appointmentAnalytics={appointmentAnalytics}
            getResponseRecivedByAttemp={getResponseRecivedByAttemp}
            setResponseRecievedByAttempFilter={setResponseRecievedByAttempFilter}
            setuserIds={setuserIds}
            type={props.type || "GROUP"}
          />
        )}
      </div>
      {!userCondition && (
        <AnalyticsPagination
          total={analytics.count}
          pageSize={params?.pageSize || 0}
          length={analytics.data.length / 3}
          onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
          page={params.page}
        />
      )}
    </div>
  );
};
const AppointmentBySalesPersonGraph = ({
  userIds,
  responseRecievedByAttempFilter,
  userCondition,
  setappointmentAnalytics,
  appointmentAnalytics,
  getResponseRecivedByAttemp,
  setResponseRecievedByAttempFilter,
  setuserIds,
  type,
}) => {
  const { loading: appointmentLoader } = useQuery(GET_APPOINTMENTS_BY_SALES_PERSON, {
    variables: {
      userIds,
      filterType: responseRecievedByAttempFilter,
      fields: ["scheduled", "showed", "no_showed"],
      outputFormat: "distributed_object",
      orderDirection: "desc",
      orderBy: "showed",
      pageSize: 3,
    },
    onCompleted: res => {
      setappointmentAnalytics(
        res?.getAppointmentSalesperson?.distributedData?.map(item => ({
          ...item,
          userFullName: item.user.fullName,
          fieldName: capitalize(item.name.replace("_", " ")),
        }))
      );
    },
  });
  return (
    <GraphAnalysis
      graphKey="messageSentRecieved"
      label="Messages Sent vs. Received"
      data={appointmentAnalytics}
      width={8}
      colors={["#FACC15", "#FB923C", "#EF4444"]}
      API={getResponseRecivedByAttemp}
      filterType={responseRecievedByAttempFilter}
      setFilterType={setResponseRecievedByAttempFilter}
      loader={appointmentLoader}
      onChangeUsers={userIds => setuserIds(userIds)}
      userIds={userIds}
      type={type || "GROUP"}
      xField="userFullName"
      yField="value"
      seriesField="fieldName"
      pagination={false}
      showFilters={false}
    />
  );
};
/**
 * ![Engagement Analysis](https://img001.prntscr.com/file/img001/td9rbCINS4S-nCWJl3sI6Q.png)
 * ### [Figma Link](https://www.figma.com/design/NDVwkatBby4TFCN5oag0D1/1.-Web?node-id=12729-13146&t=ojvDzhXjpXYtiRcI-4)
 * @returns
 */
export const EngagementAnalysis = () => {
  const [engagementAnalysisFilter, setEngagementAnalysisFilter] = useState(LAST_30_DAYS);
  const [dateRange, setDateRange] = useState([]);
  const { data: resp, loading: engagementAnalyticsLoader } = useQuery(GET_ENGAGEMENT_ANALYTICS, {
    fetchPolicy: "network-only",
    variables: { filterType: engagementAnalysisFilter, dateRange },
  });
  const analyticsData = resp?.getEngagementAnalytics || [];
  const counts = useMemo(() => activityAnalysis(filterByRange(analyticsData)), [analyticsData]);

  const getCount = useCallback(
    title => {
      const item = counts.find(count => count.title === title);
      return item?.count || 0;
    },
    [counts]
  );
  const engagementData = useMemo(
    () => [
      { label: "Sent Messages", value: getCount("Total Messages Sent") },
      {
        label: "Received Messages",
        value: getCount("Total Messages") - getCount("Total Messages Sent"),
      },
      // { label: "Engagements", value: getCount("Engagements") },
      // { label: "Active Engagements", value: getCount("Active Engagements") },
    ],
    [getCount]
  );

  const renderDataItem = ({ label, value, isRed }) => (
    <div key={label} className="flex-col-centered">
      <span className="engagement-analysis-label">{label}</span>
      <Skeleton loading={engagementAnalyticsLoader} active paragraph={{ rows: 0 }}>
        <span className={`engagement-analysis-value ${isRed ? "text-red-500" : ""}`}>{value}</span>
      </Skeleton>
    </div>
  );

  return (
    <div className="flex-col-centered items-start">
      <div className="flex-row-centered w-full mb-10 justify-between">
        <span className="dashboard-title-label">Engagement Analysis</span>
        <FilterSelector
          filterType={engagementAnalysisFilter}
          handleFilter={setEngagementAnalysisFilter}
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
      </div>
      <div className="flex-row-centered w-full">
        <EngagementVector />
        <div className="flex-col-centered gap-1 pl-2 w-[calc(100%-153px)]">
          {/* {[0].map(index => (
            <div
              key={index}
              className="border-dashed border flex-row-centered items-center justify-between border-grey-300 rounded-lg px-6 py-3 w-full"
            >
              {renderDataItem(engagementData[index * 2])}
              {renderDataItem(engagementData[index * 2 + 1])}
            </div>
          ))} */}
          <div className="flex-row-centered w-full gap-4">
            {engagementData.map((item, index) => {
              return (
                <div
                  key={index}
                  className="border-dashed w-1/2 rounded-lg px-6 py-3 border border-grey-300 flex-col-centered"
                >
                  <span className="text-xs text-[14px] font-[400] text-grey-500">{item.label}</span>
                  <Skeleton active paragraph={{ rows: 0 }} loading={engagementAnalyticsLoader}>
                    <span className="font-[600] text-lg text-grey-700">{item.value}</span>
                  </Skeleton>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * ![Appointment analysis](https://img001.prntscr.com/file/img001/RuqhP-wFQXSAdgimm16WSw.png)
 * ### [Figma Link](https://www.figma.com/design/NDVwkatBby4TFCN5oag0D1/1.-Web?node-id=12729-13206&t=ojvDzhXjpXYtiRcI-4)
 * @returns
 */
export const AppointmentAnalysis = () => {
  const [appointmentAnalysisFilter, setAppointmentAnalysisFilter] = useState(LAST_30_DAYS);
  const [dateRange, setDateRange] = useState([]);
  const {
    data: resAppointments,
    refetch: getAppointmentAnalysis,
    loading: appointmentAnalysisLoader,
  } = useQuery(GET_APPOINTMENT_ANALYSIS, {
    fetchPolicy: "network-only",
    variables: {
      filterType: appointmentAnalysisFilter,
      dateRange,
    },
  });
  const data = useMemo(
    () => appointmentsAnalytics(filterByRange(resAppointments?.getAppointmentAnalysis.data)),
    [resAppointments?.getAppointmentAnalysis.data]
  );
  const growthRate = useMemo(() => {
    const scheduledAppointments = resAppointments?.getAppointmentAnalysis?.data?.find(
      item => item.title === "SCHEDULED"
    );
    if (scheduledAppointments) {
      return {
        trend: scheduledAppointments?.growthRate < 0 ? "DOWN" : "UP",
        percent: scheduledAppointments?.growthRate
          ? Math.abs(scheduledAppointments?.growthRate).toString()
          : 0,
      };
    }
    return {
      trend: "DOWN",
      percent: 0,
    };
  }, [resAppointments]);
  const total = useMemo(() => {
    return data.reduce((acc, curr) => acc + curr.count, 0);
  }, [data]);
  const count = data.reduce((total, item) => total + item.count, 0);
  const config = {
    data: data.map(item => ({
      ...item,
      title: capitalize(convertToTitleCase(item.title)).replace(/\s+/g, ""),
    })),
    angleField: "count",
    colorField: "title",
    radius: 0.8,
    innerRadius: 0.6,
    label: false,
    interactions: [{ type: "element-selected" }, { type: "element-active" }],
    statistic: {
      title: {
        style: { fontSize: 14 },
        formatter: () => "Total Appoint.",
      },
      content: {
        style: { fontSize: 24 },
        formatter: () => total,
      },
    },

    legend: {
      itemName: {
        formatter: (text, item) => {
          const dataItem = data.find(
            d => capitalize(convertToTitleCase(d.title)).replace(/\s+/g, "") === item.value
          );
          if (dataItem) {
            return `${text}: ${dataItem.count} (${Math.floor((dataItem.count / count) * 100)}%)`;
          }
          return text;
        },
      },
    },
    // Add title configuration at the root level
    title: {
      visible: true,
      text: "My Custom Pie Chart Title",
      style: {
        fontSize: 16,
        fontWeight: "bold",
        textAlign: "center",
      },
    },
  };
  return (
    <>
      <div className="flex-row-centered justify-between">
        <span className="dashboard-title-label">Appointment analysis</span>
        <FilterSelector
          filterType={appointmentAnalysisFilter}
          handleFilter={setAppointmentAnalysisFilter}
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
      </div>
      <div className="flex justify-center my-1">
        <div className="flex border border-dashed border-gray-300">
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">New Lead</span>
            <Skeleton loading={appointmentAnalysisLoader} active paragraph={{ rows: 0 }}>
              <span className="text-base font-[600] text-grey-700">
                {resAppointments?.getAppointmentAnalysis?.totalNewLeads || 0}
              </span>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-dashed" />
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Booked Appoint.</span>
            <Skeleton loading={appointmentAnalysisLoader} active paragraph={{ rows: 0 }}>
              <span className="text-base font-[600] text-grey-700">
                {resAppointments?.getAppointmentAnalysis?.totalBookedAppointments || 0}
              </span>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-dashed" />
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">% of Booked Appoint.</span>
            <Skeleton loading={appointmentAnalysisLoader} active paragraph={{ rows: 0 }}>
              <span className="text-base font-[600] text-grey-700">
                {resAppointments?.getAppointmentAnalysis?.appointmentBookingRate || 0}
              </span>
            </Skeleton>
          </div>
        </div>
      </div>
      <Skeleton loading={appointmentAnalysisLoader} className="h-[250px]" avatar active>
        <Pie className="h-[250px]" {...config} />
      </Skeleton>
      <Alert
        type={growthRate.trend === "UP" ? "success" : "error"}
        message={
          <span
            className={`${
              growthRate.trend === "UP" ? "text-green-500" : "text-red-500"
            } text-xs font-[400] flex-row-centered justify-center`}
          >
            Total appointments for {appointmentAnalysisFilter.replace(/_/g, " ").toLowerCase()}{" "}
            {growthRate.trend === "UP" ? "increased" : "decreased"} by {growthRate.percent}%
            <DashboardArrow
              color={growthRate.trend === "UP" && "#4ae081"}
              className={`${growthRate.trend === "UP" && "rotate-180"}`}
            />
          </span>
        }
      />
    </>
  );
};

/**
 * ![Appointments by sales person](https://img001.prntscr.com/file/img001/nYfab-K_Qge_HPSC18MBUg.png)
 * ### [Figma Link](https://www.figma.com/design/NDVwkatBby4TFCN5oag0D1/1.-Web?node-id=12729-12836&t=ojvDzhXjpXYtiRcI-4)
 * @returns
 */
export const AppointmentBySalesPerson = () => {
  const [appointmentBySalesPersonFilter, setAppointmentBySalesPersonFilter] =
    useState(LAST_30_DAYS);
  const [appointmentData, setAppointmentData] = useState({
    data: [],
    count: 0,
  });
  const [dateRange, setDateRange] = useState([]);
  const [params, setparams] = useState({
    page: 1,
    pageSize: 6,
  });
  const [userIds, setuserIds] = useState([]);
  const { loading: salesPersonLoader } = useQuery(GET_APPOINTMENTS_BY_SALES_PERSON, {
    fetchPolicy: "network-only",
    variables: {
      filterType: appointmentBySalesPersonFilter,
      userIds,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setAppointmentData(res.getAppointmentSalesperson);
    },
  });
  const Columns = [
    {
      title: "Name",
      width: "15%",
      fixed: "left",
      render: (text, record, index) => (
        <span className="flex-row-centered gap-1" key={index}>
          <Avatar className="w-6 h-6 bg-grey-700" size="small" src={record.user.profilePic}>
            {convertToInitials(record.user.fullName)}
          </Avatar>
          <Tooltip title={record?.user.fullName || ""}>
            <span className="ellipsis max-w-[150px]">{record?.user.fullName || ""}</span>
          </Tooltip>
        </span>
      ),
    },
    {
      title: <Tooltip title="No. of Opportunities">No. of Opp.</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span>{record.totalOpportunities}</span>,
    },
    {
      title: <Tooltip title="Scheduled">Scheduled</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record?.scheduled || 0}</span>,
    },
    {
      title: <Tooltip title="Confirmed">Confirmed</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record?.confirmed || 0}</span>,
    },
    {
      title: <Tooltip title="Showed">Showed</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record.showed || 0}</span>,
    },
    {
      title: <Tooltip title="Sold">Sold</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record.sold || 0}</span>,
    },
    {
      title: <Tooltip title="No-Showed">No-Showed</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record.noShowed || 0}</span>,
    },
    {
      title: <Tooltip title="Re-Scheduled">Re-Scheduled</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record.rescheduled || 0}</span>,
    },
    {
      title: <Tooltip title="Cancelled">Cancelled</Tooltip>,
      width: "6%",
      render: (text, record, index) => <span key={index}>{record.cancelled || 0}</span>,
    },
    // {
    //   title: "Other",
    //   width: "8%",
    //   render: (text, record, index) => (
    //     <Popover
    //       key={index}
    //       placement="bottom"
    //       arrow={false}
    //       content={
    //         <div className="flex-col-centered gap-2 w-[150px]">
    //           <div className="flex-row-centered justify-between">
    //             <span className="text-sm font-[400] text-grey-700">No-Showed</span>
    //             <span className="text-sm font-[400] text-grey-700">{record.noShowed || 0}</span>
    //           </div>
    //           <div className="flex-row-centered justify-between">
    //             <span className="text-sm font-[400] text-grey-700">Rescheduled</span>
    //             <span className="text-sm font-[400] text-grey-700">{record?.rescheduled || 0}</span>
    //           </div>
    //           <div className="flex-row-centered justify-between">
    //             <span className="text-sm font-[400] text-grey-700">Cancelled</span>
    //             <span className="text-sm font-[400] text-grey-700">{record.cancelled || 0}</span>
    //           </div>
    //         </div>
    //       }
    //       trigger={["hover"]}
    //     >
    //       <DoubleRightIcon className="cursor-pointer" />
    //     </Popover>
    //   ),
    // },
  ];

  return (
    <div className="flex-col-centered gap-5">
      <div className="flex-row-centered justify-between">
        <span className="dashboard-title-label">Appointments by Sales Person</span>
        <div className="flex-row-centered gap-1 items-center">
          <UserSelector
            handleUsersSelection={users => {
              setuserIds(users);
              setparams({ ...params, page: 1 });
            }}
            containerClassName=""
            multiple
            allEmptyArray
            className="w-[200px]"
            userIds={userIds}
            value={userIds}
          />
          <FilterSelector
            handleFilter={value => {
              setAppointmentBySalesPersonFilter(value);
              setparams({ ...params, page: 1 });
            }}
            filterType={appointmentBySalesPersonFilter}
            dateRange={dateRange}
            setDateRange={setDateRange}
          />
        </div>
      </div>
      <Table
        size="small"
        dataSource={appointmentData.data}
        loading={salesPersonLoader}
        columns={Columns}
        className="ellipsis-table"
        pagination={false}
        scroll={{ y: 300 }}
      />
      <AnalyticsPagination
        total={appointmentData.count}
        pageSize={params.pageSize}
        page={params.page}
        pageSizeOptions={[6, 10, 20, 50, 100]}
        length={appointmentData.data.length}
        onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
      />
    </div>
  );
};

export const LeadContactedBySource = () => {
  const [lang] = useLang();
  const [pieChart, setpieChart] = useState(false);
  const [leadContactedBySourceFilter, setLeadContactedBySourceFilter] = useState(LAST_30_DAYS);
  const {
    data: leadContactSourceData,
    refetch: refetchLeadContactSourceData,
    loading: leadContactedbySourceLoader,
  } = useQuery(GET_LEAD_CONTECTED_BY_SOURCE, {
    fetchPolicy: "network-only",
    variables: {
      filterType: leadContactedBySourceFilter,
    },
  });

  const leadContactedByStatus = leadContactSourceData?.getEngagementLeadAnalytics || [];
  const conductedLeads = filterByStatus(leadContactedByStatus)([
    "SENT",
    "OPT_PUT",
    "DELIVERED",
    "RESPONDED",
    "ENGAGED",
  ]);
  return (
    <GraphAnalysis
      handleGraphChanges={value => setpieChart(value)}
      graphChanger={pieChart}
      graphKey="leadContactedBySource"
      label={lang.leadContactedBySource}
      data={leadBySource(filterByRange(conductedLeads))}
      API={refetchLeadContactSourceData}
      filterType={leadContactedBySourceFilter}
      setFilterType={setLeadContactedBySourceFilter}
      loader={leadContactedbySourceLoader}
    />
  );
};
/**
 * ![Stats](https://img001.prntscr.com/file/img001/9l2wZtUgQKONgAa5EeZaJA.png)
 * @returns
 */
export const StatsBar = () => {
  const [statsTimeFrame, setstatsTimeFrame] = useState(LAST_30_DAYS);
  const [dashboardAnalyticsData, setdashboardAnalyticsData] = useState({
    totalActiveLeads: 0,
    totalNewLeads: 0,
    totalEngagedLeads: 0,
    percentageConversion: 0,
  });
  const [dateRange, setDateRange] = useState([]);
  const { loading: getDashboardAnalyticsLoader } = useQuery(GET_DASHBOARD_ANALYTICS, {
    variables: {
      filterType: statsTimeFrame,
      dateRange,
    },
    onCompleted: res => {
      setdashboardAnalyticsData(res.getDashboardAnalytics);
    },
  });
  return (
    <div className="flex-row-centered w-full gap-4">
      <div
        // key={index}
        className="p-4 bg-white rounded-lg w-full flex-col-centered"
      >
        {/* <div className="flex-row-centered justify-end w-full">
          <FilterSelector filterType={statsTimeFrame} handleFilter={setstatsTimeFrame} />
        </div> */}
        <div className="w-full flex-row-centered justify-between">
          <div className="flex-col-centered gap-1 items-start">
            <span className="text-sm font-[400] text-grey-500">New Leads</span>
            <Skeleton loading={getDashboardAnalyticsLoader} active paragraph={{ rows: 0 }}>
              <span className="text-3xl font-[600] text-grey-700">
                {dashboardAnalyticsData.totalNewLeads || 0}
              </span>
            </Skeleton>
          </div>
          <div className="flex-col-centered gap-1 items-start">
            <span className="text-sm font-[400] text-grey-500">Engaged Leads</span>
            <Skeleton loading={getDashboardAnalyticsLoader} active paragraph={{ rows: 0 }}>
              <span className="text-3xl font-[600] text-grey-700">
                {dashboardAnalyticsData.totalEngagedLeads || 0}
              </span>
            </Skeleton>
          </div>
          <div className="flex-col-centered gap-1 items-start">
            <span className="text-sm font-[400] text-grey-500">Engagement Rate</span>
            <Skeleton loading={getDashboardAnalyticsLoader} active paragraph={{ rows: 0 }}>
              <span className="text-3xl font-[600] text-grey-700">
                {dashboardAnalyticsData.percentageConversion || 0}
              </span>
            </Skeleton>
          </div>
          {/* <div className="flex-row-centered rounded-full p-2 bg-grey-100 items-center justify-center">
            <TwoPersonIcon />
          </div> */}
          <FilterSelector
            dateRange={dateRange}
            setDateRange={setDateRange}
            filterType={statsTimeFrame}
            handleFilter={setstatsTimeFrame}
          />
        </div>
      </div>
    </div>
  );
};
/**
 * ![Leads engagement](https://img001.prntscr.com/file/img001/qwnh4_ryQvqPxlpVsqFynA.png)
 * ### [Figma Link](https://www.figma.com/design/NDVwkatBby4TFCN5oag0D1/1.-Web?node-id=12729-12724&t=ojvDzhXjpXYtiRcI-4)
 * @param {*} props
 * @returns
 */
export const LeadEngagement = props => {
  const [leadEngagementFilterType, setleadEngagementFilterType] = useState(LAST_30_DAYS);
  const [userIds, setuserIds] = useState([]);
  // const [responseRecievedByAttempFilter, setResponseRecievedByAttempFilter] = useState(LAST_30_DAYS);
  const [analytics, setanalytics] = useState({ data: [], count: 0 });
  const [dateRange, setDateRange] = useState([]);
  const dispatch = useDispatch();
  const [params, setparams] = useState({
    page: 1,
    pageSize: 10,
  });
  const { loading: leadEngagementAnalysisLoader } = useQuery(GET_LEAD_ENGAGEMENT_ANALYSIS, {
    fetchPolicy: "network-only",
    variables: {
      filterType: leadEngagementFilterType,
      userIds,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setanalytics(res.getLeadEngagementAnalysis);
    },
  });
  const viewInActivityCenter = status => {
    dispatch(setQuickFilters([status]));
    navigate(`/engagements/activity-center`);
    window.history.pushState("", "", `/engagements/activity-center`);
  };
  return (
    <div className="flex-col-centered gap-1">
      <div className="flex-row-centered justify-between w-full">
        <span className="dashboard-title-label">Lead Engagement</span>
        <div className="flex-row-centered gap-1 items-center">
          <UserSelector
            containerClassName=""
            handleUsersSelection={users => {
              setuserIds(users);
              setparams({ ...params, page: 1 });
            }}
            multiple
            allEmptyArray
            className="w-[200px]"
            userIds={userIds}
            value={userIds}
          />
          <FilterSelector
            filterType={leadEngagementFilterType}
            handleFilter={value => {
              setleadEngagementFilterType(value);
              setparams({ ...params, page: 1 });
            }}
            dateRange={dateRange}
            setDateRange={setDateRange}
          />
        </div>
      </div>
      {/* Summary */}
      <div className="flex justify-center">
        <div className="flex border border-dashed border-gray-300">
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Responded Leads</span>
            <Skeleton loading={leadEngagementAnalysisLoader} active paragraph={{ rows: 0 }}>
              <Tooltip title="View Leads in activity center">
                <span
                  onClick={() => viewInActivityCenter("RESPONDED")}
                  className="text-base font-[600] text-brand-500 cursor-pointer"
                >
                  {analytics?.awaitingResponse || 0}
                </span>
              </Tooltip>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-dashed" />
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Not Responded Leads</span>
            <Skeleton loading={leadEngagementAnalysisLoader} active paragraph={{ rows: 0 }}>
              <Tooltip title="View Leads in activity center">
                <span
                  onClick={() => viewInActivityCenter("WAITING_FOR_REPLY")}
                  className="text-base font-[600] text-brand-500 cursor-pointer"
                >
                  {analytics?.notContacted || 0}
                </span>
              </Tooltip>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-dashed" />
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Needs Engagement</span>
            <Skeleton loading={leadEngagementAnalysisLoader} active paragraph={{ rows: 0 }}>
              <Tooltip title="View Leads in activity center">
                <span
                  onClick={() => viewInActivityCenter("UNCONTACTED")}
                  className="text-base font-[600] text-brand-500 cursor-pointer"
                >
                  {analytics?.needsEngagement || 0}
                </span>
              </Tooltip>
            </Skeleton>
          </div>
        </div>
      </div>
      <GraphAnalysis
        graphKey="messageSentRecieved"
        colors={["#FB923C", "#5B8FF9"]}
        data={analytics.data.map(item => ({
          userFullName: item.user.fullName,
          value: item.value,
          name: convertToTitleCase(item.name),
        }))}
        width={16}
        showFilters={false}
        filterType={leadEngagementFilterType}
        setFilterType={setleadEngagementFilterType}
        loader={leadEngagementAnalysisLoader}
        onChangeUsers={userIds => setuserIds(userIds)}
        userIds={userIds}
        type={props.type || "GROUP"}
        xField="userFullName"
        yField="value"
        seriesField="name"
        pagination={false}
      />
      <AnalyticsPagination
        total={analytics.count}
        pageSize={params?.pageSize || 0}
        length={analytics.data.length / 2}
        onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
        page={params.page}
      />
    </div>
  );
};

export const SourceGraph = props => {
  const [sourceFilterType, setsourceFilterType] = useState(LAST_30_DAYS);
  const [selectedType, setselectedType] = useState("APPOINTMENT");
  const [params, setParams] = useState({
    page: 1,
    pageSize: 10,
  });
  const [dateRange, setDateRange] = useState([]);
  const [sourceData, setsourceData] = useState({
    data: [],
    count: 0,
  });
  const { loading: sourceLoader } = useQuery(GET_DATA_BY_SOURCE, {
    variables: {
      filterType: sourceFilterType,
      dataType: selectedType,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setsourceData(res.getDataBySource);
    },
  });
  const config = {
    data: sourceData.data.map(item => ({
      ...item,
      name: convertToTitleCase(item.name),
    })),
    isStack: true,
    xField: "value",
    yField: "sourceName",
    seriesField: "name",
    label: false,
    color: ["#3B82F6", "#10B981", "#F59E0B", "#84CC16", "#F43F5E", "#14B8A6", "#EF4444"],
    maxBarWidth: 8,
  };
  const handleClick = key => {
    setParams({ ...params, page: 1 });
    setselectedType(key);
  };
  return (
    <div>
      <div className="flex-row-centered w-full justify-between">
        <span className="flex-row-centered gap-1 dashboard-title-label">
          <Dropdown
            menu={{
              items: [
                {
                  label: "Appointment",
                  key: "APPOINTMENT",
                },
                {
                  label: "Lead",
                  key: "LEAD_OPPORTUNITY",
                },
                {
                  label: "Responses",
                  key: "RESPONSES",
                },
              ],
              onClick: e => handleClick(e.key),
            }}
          >
            <span className="flex-row-centered gap-1 cursor-pointer text-brand-500">
              {convertToTitleCase(capitalize(selectedType))}
              <DownIcon />
            </span>
          </Dropdown>
          by Sources
        </span>
        <FilterSelector
          filterType={sourceFilterType}
          handleFilter={value => {
            setsourceFilterType(value);
            setParams({ ...params, page: 1 });
          }}
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
      </div>
      <Skeleton className="h-[400px]" loading={sourceLoader} active avatar>
        <Bar {...config} />
      </Skeleton>
      <AnalyticsPagination
        length={sourceData.data.length / (selectedType === "APPOINTMENT" ? 6 : 2)}
        page={params.page}
        pageSize={params.pageSize}
        onChange={(page, pageSize) => setParams({ page: page, pageSize: pageSize })}
        total={sourceData.count}
      />
    </div>
  );
};

export const MessageType = props => {
  const [params, setparams] = useState({
    page: 1,
    pageSize: 10,
  });
  const [dateRange, setDateRange] = useState([]);
  const [userIds, setuserIds] = useState([]);
  const [messageTypeFilter, setmessageTypeFilter] = useState(LAST_30_DAYS);
  const [messageTypeData, setmessageTypeData] = useState({
    data: [],
    count: 0,
  });
  const { loading: messageTypeLoader } = useQuery(GET_USER_MESSAGE_TYPE_ANALYSIS, {
    variables: {
      filterType: messageTypeFilter,
      userIds,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setmessageTypeData(res.getUserMessageTypeAnalysis);
    },
  });
  const columns = [
    {
      title: "",
      render: (text, record, index) => (
        <span className="flex-row-centered gap-1" key={index}>
          <Avatar className="w-6 h-6 bg-grey-700" size="small" src={record.user.profilePic}>
            {convertToInitials(record.user.fullName)}
          </Avatar>
          <Tooltip title={record?.user.fullName || ""}>
            <span className="ellipsis max-w-[150px]">{record?.user.fullName || ""}</span>
          </Tooltip>
        </span>
      ),
    },
    {
      title: (
        <div className="bg-grey-100 xs-400 px-2 py-1 flex-row-centered gap-2 rounded text-grey-700">
          <Icon className="text-sm" component={EngagedAI} alt="SocialMiningAi" />
          Otto Generated
        </div>
      ),
      dataIndex: "ottoGenerated",
    },
    {
      title: (
        <div className="bg-grey-100 xs-400 flex-row-centered px-2 py-1 gap-2 rounded text-grey-700">
          <PencilIcon />
          Self written
        </div>
      ),
      dataIndex: "selfWritten",
    },
  ];
  return (
    <div className="flex-col-centered gap-2">
      <div className="flex-row-centered justify-between">
        <h2 className="dashboard-title-label">Message Type</h2>
        <div className="flex-row-centered gap-1">
          <UserSelector
            containerClassName=""
            handleUsersSelection={users => {
              setuserIds(users);
              setparams({ ...params, page: 1 });
            }}
            multiple
            allEmptyArray
            className="w-[200px]"
            userIds={userIds}
            value={userIds}
          />
          <FilterSelector
            dateRange={dateRange}
            setDateRange={setDateRange}
            filterType={messageTypeFilter}
            handleFilter={setmessageTypeFilter}
          />
        </div>
      </div>
      <Table
        bordered={false}
        loading={messageTypeLoader}
        dataSource={messageTypeData.data}
        columns={columns}
        pagination={false}
        scroll={{ y: 300 }}
        className="transparent-header-tb"
      />
      <AnalyticsPagination
        total={messageTypeData.count}
        pageSize={params.pageSize}
        page={params.page}
        pageSizeOptions={[6, 10, 20, 50, 100]}
        length={messageTypeData.data.length}
        onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
      />
    </div>
  );
};

export const ResponseTime = props => {
  const [params, setparams] = useState({
    page: 1,
    pageSize: 10,
  });
  const [userIds, setuserIds] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [messageTypeFilter, setmessageTypeFilter] = useState(LAST_30_DAYS);
  const [responseTimeData, setresponseTimeData] = useState({
    data: [],
    count: 0,
    averageBestTime: 0,
    averageWorstTime: 0,
    averageTime: 0,
    trend: "",
    percentageChange: 0,
    averageResponseTimeAfterNudge: 0,
  });
  const { loading: responseTimeLoader } = useQuery(GET_USER_MESSAGE_RESPONSE_TIME_ANALYSIS, {
    variables: {
      filterType: messageTypeFilter,
      userIds,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setresponseTimeData(res.getUserMessageResponseTimeAnalysis);
    },
  });
  const columns = [
    {
      title: "(in minutes)",
      width: "35%",
      render: (text, record, index) => (
        <div key={index} className="flex-row-centered gap-1">
          <Avatar className="w-6 h-6 bg-grey-700" size="small" src={record.user.profilePic}>
            {convertToInitials(record.user.fullName)}
          </Avatar>
          <Tooltip title={record?.user.fullName || ""}>
            <span className="ellipsis max-w-[120px]">{record?.user.fullName || ""}</span>
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <span className="flex-row-centered text-xs font-[400] text-grey-700 items-center justify-center py-1 px-2 rounded bg-success-100">
          Best Time
        </span>
      ),
      dataIndex: "bestTime",
    },
    {
      title: (
        <span className="flex-row-centered text-xs font-[400] text-grey-700 items-center justify-center py-1 px-2 rounded bg-red-100">
          Worst Time
        </span>
      ),
      dataIndex: "worstTime",
    },
    {
      title: (
        <span className="flex-row-centered text-xs font-[400] text-grey-700 items-center justify-center py-1 px-2 rounded bg-grey-100">
          Avg. Time
        </span>
      ),
      dataIndex: "averageTime",
    },
  ];
  return (
    <div className="flex-col-centered gap-2">
      <div className="flex-row-centered justify-between">
        <h2 className="dashboard-title-label">Response Time</h2>
        <div className="flex-row-centered gap-1">
          <UserSelector
            containerClassName=""
            handleUsersSelection={users => {
              setuserIds(users);
              setparams({ ...params, page: 1 });
            }}
            multiple
            allEmptyArray
            className="w-[200px]"
            userIds={userIds}
            value={userIds}
          />
          <FilterSelector
            dateRange={dateRange}
            setDateRange={setDateRange}
            filterType={messageTypeFilter}
            handleFilter={setmessageTypeFilter}
          />
        </div>
      </div>
      <div className="w-full mt-2 bg-grey-50">
        <div className="flex border border-solid border-gray-300">
          {/* <div className="flex flex-col w-1/3 items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Avg. Best Time</span>
            <Skeleton loading={responseTimeLoader} active paragraph={{ rows: 0 }}>
              <span className="text-base font-[600] text-grey-700">
                {convertMinutesToHour(responseTimeData.averageBestTime)} min
              </span>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-solid" />
          <div className="flex flex-col w-1/3 items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Avg. Worst Time</span>
            <Skeleton loading={responseTimeLoader} active paragraph={{ rows: 0 }}>
              <span className="text-base font-[600] text-grey-700">
                {convertMinutesToHour(responseTimeData.averageWorstTime)} min
              </span>
            </Skeleton>
          </div> */}
          <div className="flex flex-col w-1/2 items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Avg. Time (KPI: 20 Min)</span>
            <Skeleton loading={responseTimeLoader} active paragraph={{ rows: 0 }}>
              <div className="flex-row-centered gap-1 items-center">
                <span className="text-base font-[600] text-grey-700">
                  {convertMinutesToHour(responseTimeData.averageTime)} min
                </span>
                <Tag
                  className="flex-row-centered items-center gap-0.5"
                  color={responseTimeData.trend === "up" ? "green" : "red"}
                >
                  {responseTimeData.percentageChange !== "N/A"
                    ? `${responseTimeData.percentageChange}%`
                    : ""}
                  {responseTimeData.trend === "up" ? (
                    <DashboardArrow color="#22c55e" className="rotate-180" />
                  ) : (
                    <DashboardArrow />
                  )}
                </Tag>
              </div>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-solid" />
          <div className="flex flex-col w-1/2 items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">
              Avg. Response Time After Nudge
            </span>
            <Skeleton loading={responseTimeLoader} active paragraph={{ rows: 0 }}>
              <span className="text-base font-[600] text-grey-700">
                {convertMinutesToHour(responseTimeData.averageResponseTimeAfterNudge)} min
              </span>
            </Skeleton>
          </div>
        </div>
      </div>
      <Table
        bordered={false}
        loading={responseTimeLoader}
        dataSource={responseTimeData.data}
        columns={columns}
        pagination={false}
        scroll={{ y: 300 }}
        className="transparent-header-tb"
      />
      <AnalyticsPagination
        total={responseTimeData.count}
        pageSize={params.pageSize}
        page={params.page}
        pageSizeOptions={[6, 10, 20, 50, 100]}
        length={responseTimeData.data.length}
        onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
      />
    </div>
  );
};

export const ReviewRequestAnalysis = props => {
  const [params, setparams] = useState({
    page: 1,
    pageSize: 6,
  });
  const [userIds, setuserIds] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [reviewInviteAnalyticsData, setreviewInviteAnalyticsData] = useState({
    data: [],
    count: 0,
  });
  const [reviewRequestAnalysisFilter, setreviewRequestAnalysisFilter] = useState(LAST_30_DAYS);
  const { loading: userReviewAnalysisLoader } = useQuery(GET_USER_REVIEW_ANALYSIS, {
    variables: {
      filterType: reviewRequestAnalysisFilter,
      userIds,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setreviewInviteAnalyticsData(res.getUserReviewAnalysis);
    },
  });
  const viewInActivityCenter = () => {
    navigate(`/engagements/activity-center`);
    window.history.pushState("", "", `/engagements/activity-center`);
  };
  return (
    <div>
      <div className="flex-row-centered justify-between w-full">
        <span className="dashboard-title-label">Review Request Analysis</span>
        <div className="flex-row-centered gap-1">
          <UserSelector
            containerClassName=""
            handleUsersSelection={users => {
              setuserIds(users);
              setparams({ ...params, page: 1 });
            }}
            multiple
            allEmptyArray
            className="w-[200px]"
            userIds={userIds}
            value={userIds}
          />
          <FilterSelector
            filterType={reviewRequestAnalysisFilter}
            dateRange={dateRange}
            setDateRange={setDateRange}
            handleFilter={setreviewRequestAnalysisFilter}
          />
        </div>
      </div>
      <div className="flex justify-center mt-1">
        <div className="flex border border-dashed border-gray-300">
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Invite Sent</span>
            <Skeleton loading={userReviewAnalysisLoader} active paragraph={{ rows: 0 }}>
              <span
                onClick={() => viewInActivityCenter()}
                className="text-base font-[600] text-brand-500 cursor-pointer"
              >
                {reviewInviteAnalyticsData.totalInviteSents || 0}
              </span>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-dashed" />
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Review Completed</span>
            <Skeleton loading={userReviewAnalysisLoader} active paragraph={{ rows: 0 }}>
              <span
                onClick={() => viewInActivityCenter()}
                className="text-base font-[600] text-brand-500 cursor-pointer"
              >
                {reviewInviteAnalyticsData.totalReviewCompleted || 0}
              </span>
            </Skeleton>
          </div>
          <div className="w-px border-gray-300 border border-dashed" />
          <div className="flex flex-col items-center gap-1 p-3">
            <span className="text-sm text-gray-500 font-normal">Invite Not Sent</span>
            <Skeleton loading={userReviewAnalysisLoader} active paragraph={{ rows: 0 }}>
              <span
                onClick={() => viewInActivityCenter()}
                className="text-base font-[600] text-brand-500 cursor-pointer"
              >
                {reviewInviteAnalyticsData.totalInviteNotSents || 0}
              </span>
            </Skeleton>
          </div>
        </div>
      </div>
      <Skeleton className="h-[250px]" loading={userReviewAnalysisLoader} avatar active>
        <Column
          data={reviewInviteAnalyticsData.data.map(item => ({
            value: item.value,
            userFullName: item.user.fullName,
            name: convertToTitleCase(item.name),
          }))}
          xField="userFullName"
          yField="value"
          seriesField="name"
          isGroup
          columnStyle={{ radius: [20, 20, 20, 20] }}
          maxColumnWidth={10}
          className="mb-2"
          xAxis={{
            label: {
              formatter: text => {
                return text
                  .split(" ")
                  .map(word => word[0])
                  .join("");
              },
              // autoHide: false,
            },
          }}
          color={["#5B8FF9", "#5AD8A6", "#4e4d54"]}
        />
      </Skeleton>
      <AnalyticsPagination
        total={reviewInviteAnalyticsData.count}
        pageSize={params.pageSize}
        page={params.page}
        // className="mt-3"
        pageSizeOptions={[6, 10, 20, 50, 100]}
        length={reviewInviteAnalyticsData.data.length / 3}
        onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
      />
    </div>
  );
};

export const ReviewStatus = props => {
  const [reviewStatusFilter, setreviewStatusFilter] = useState(LAST_30_DAYS);
  const [reviewStatusData, setreviewStatusData] = useState({
    count: 0,
    data: [],
  });
  const [params, setparams] = useState({
    page: 1,
    pageSize: 6,
  });
  const [dateRange, setDateRange] = useState([]);
  const [reviewStatus, setreviewStatus] = useState("");
  const { loading: reviewStatusAnalysisLoader } = useQuery(GET_REVIEW_STATUS_ANALYSIS, {
    variables: {
      filterType: reviewStatusFilter,
      reviewStatus,
      dateRange,
      ...params,
    },
    onCompleted: res => {
      setreviewStatusData(res.getReviewStatusAnalysis);
    },
  });
  const reviewStatusRender = key => {
    switch (key) {
      case "review_completed":
        return <span className="text-success-500 xs-400">{convertToTitleCase(key)}</span>;
      case "invites_sent":
        return <span className="text-orange-500 xs-400">Request sent</span>;
      case "invite_not_sent":
        return (
          <div className="flex-col-centered items-start gap-1">
            <span className="text-red-500 xs-400">Request Not Sent</span>
            {/* <Button disabled className="border-brand-500 text-brand-500">
              Send Request
            </Button> */}
          </div>
        );
      default:
        break;
    }
  };
  const columns = [
    {
      title: "Lead and Vehicle",
      render: (text, record, index) => (
        <span key={index}>
          {/* <Image /> */}
          <div className="flex-col-centered items-start">
            <span className="text-sm font-[500] text-grey-700">{record?.lead?.fullName}</span>
            <span>
              {(record?.lead?.vehicleOfInterest || []).map((item, index) => (
                <span className="text-xs font-[400] text-grey-700" key={index}>
                  {parseVehicle(item)}
                </span>
              ))}
            </span>
          </div>
        </span>
      ),
    },
    {
      title: "Sold By",
      render: (text, record, index) => (
        <span key={index} className="flex-col-centered gap-1">
          <span className="text-sm font-[500] text-grey-700">{record.user.fullName}</span>
          <span>{record.soldDate && dayjs(record.soldDate).format("MMM DD, YYYY")}</span>
        </span>
      ),
    },
    {
      title: "Status",
      render: (text, record, index) => <span key={index}>{reviewStatusRender(record.status)}</span>,
    },
  ];
  return (
    <div>
      <div className="flex-row-centered justify-between">
        <span className="dashboard-title-label">Review Status</span>
        <div className="flex-row-centered gap-1">
          <Select
            placeholder="Review Status"
            options={[
              {
                label: "Review Completed",
                value: "review_completed",
              },
              {
                label: "Review request not sent",
                value: "invite_not_sent",
              },
              {
                label: "Review sent",
                value: "invites_sent",
              },
            ]}
            onSelect={setreviewStatus}
          />
          <FilterSelector
            dateRange={dateRange}
            setDateRange={setDateRange}
            filterType={reviewStatusFilter}
            handleFilter={setreviewStatusFilter}
          />
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={reviewStatusData.data}
        loading={reviewStatusAnalysisLoader}
        pagination={false}
        scroll={{ y: 300 }}
        className="transparent-header-tb"
      />
      <AnalyticsPagination
        total={reviewStatusData.count}
        pageSize={params.pageSize}
        page={params.page}
        className="mt-2"
        pageSizeOptions={[6, 10, 20, 50, 100]}
        length={reviewStatusData.data.length}
        onChange={(page, pageSize) => setparams({ page: page, pageSize: pageSize })}
      />
    </div>
  );
};
